module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/project-list/project-list.component.scss
// module id = ./src/app/components/project-list/project-list.component.scss
// module chunks = main